import { render, staticRenderFns } from "./space-reservation-record.vue?vue&type=template&id=5e7b8030&scoped=true"
import script from "./space-reservation-record.vue?vue&type=script&lang=js"
export * from "./space-reservation-record.vue?vue&type=script&lang=js"
import style0 from "./space-reservation-record.vue?vue&type=style&index=0&id=5e7b8030&prod&scoped=true&lang=css"
import style1 from "./space-reservation-record.vue?vue&type=style&index=1&id=5e7b8030&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7b8030",
  null
  
)

export default component.exports